import { createStore } from 'vuex';
import user from './modules/user'
import menu from './modules/menu'
import registered from './modules/registered'
import error from './modules/error'
import getters from './getters'
const store = createStore({
    modules: {
        // TODO 引入项目中所有的状态管理模块
        user,
        menu,
        registered,
        error
    },
    getters
});
export default store;